import CryptoJS from "crypto-js";

export const md5hash = (uid: string) => CryptoJS.MD5(uid).toString(CryptoJS.enc.Hex);
export const b64encode = (s: any) => CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(JSON.stringify(s)));
export const b64decode = (s: string) => JSON.parse(CryptoJS.enc.Base64.parse(s).toString(CryptoJS.enc.Utf8));
export const b64encodeStr = (s: any) => CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(s));
export const b64decodeStr = (s: string) => CryptoJS.enc.Base64.parse(s).toString(CryptoJS.enc.Utf8);
